module.exports = __webpack_public_path__ + "img/pic_sy_none@2x.ec715b1e.png";